import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      innerHTML: _ctx.$t('AdStatisticsList.ads', { adCount: _ctx.statistics.adCount, adPublishedCount: _ctx.statistics.adPublishedCount, adUnpublishedCount: _ctx.statistics.adUnpublishedCount })
    }, null, 8, _hoisted_1),
    _createElementVNode("div", {
      innerHTML: _ctx.$t('AdStatisticsList.published', { adPublishedLastWeek: _ctx.statistics.adPublishedLastWeek, adPublishedLastMonth: _ctx.statistics.adPublishedLastMonth, adPublishedLastYear: _ctx.statistics.adPublishedLastYear })
    }, null, 8, _hoisted_2),
    _createElementVNode("div", {
      innerHTML: _ctx.$t('AdStatisticsList.views', { adViewLastWeek: _ctx.statistics.adViewLastWeek, adViewLastMonth: _ctx.statistics.adViewLastMonth, adViewLastYear: _ctx.statistics.adViewLastYear })
    }, null, 8, _hoisted_3),
    _createElementVNode("div", {
      innerHTML: _ctx.$t('AdStatisticsList.interested', { adInterestedLastWeek: _ctx.statistics.adInterestedLastWeek, adInterestedLastMonth: _ctx.statistics.adInterestedLastMonth, adInterestedLastYear: _ctx.statistics.adInterestedLastYear })
    }, null, 8, _hoisted_4)
  ]))
}